@if (
  userSummary() === undefined ||
  standalonePageService.standalone() === undefined
) {
} @else if (standalonePageService.standalone() === true) {
  <ng-container *ngTemplateOutlet="router" />
} @else if (userSummary() === null) {
  <div class="container">
    <ng-container *ngTemplateOutlet="router" />
  </div>
} @else if (userSummary()) {
  <app-logged-in-layout>
    <ng-container *ngTemplateOutlet="router" />
  </app-logged-in-layout>
}

<ng-template #router>
  <router-outlet />
</ng-template>

@defer {
  <standard-focus-ring-helper />
}
